import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadUserHistoryRequestDTO extends PerformedByRequestDTO {
    userEmail?: string;
    roleCd?: string;
    contextCd?: string;
    profileCd?: string;
    userRoleContextId?: number;
    userRoleContextProfileId?: number;
    historyActionPerformedBy?: string;
    filterText?: string;
    languageCd?: string;
}
